/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';

export default function loadResourcesSlice(options) {
  const { pluralResource, repository } = options;

  return {
    initialState: {
      [pluralResource]: {
        loadingStatus: FETCH_STATUSES.idle,
        items: [],
        error: null,
        count: null,
        next: null,
        previous: null,
      },
    },
    reducers: {
      loadResourcesStart(state) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.pending;
        state[pluralResource].items = [];
        state[pluralResource].error = null;
      },
      loadResourcesSuccess(state, { payload }) {
        const { results, data, count = null, next = null, previous = null } = payload;
        state[pluralResource].loadingStatus = FETCH_STATUSES.fulfilled;
        state[pluralResource].items = results || data;
        state[pluralResource].count = count;
        state[pluralResource].next = next;
        state[pluralResource].previous = previous;
      },
      loadResourcesFail(state, { payload: { error } }) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.failed;
        state[pluralResource].error = error;
      },
    },
    actionCreators(restDispatch) {
      return {
        loadResources: (...params) => {
          restDispatch('loadResourcesStart');

          return repository
            .index(...params)
            .then(({ data }) => {
              restDispatch('loadResourcesSuccess', data);
            })
            .catch(error => {
              restDispatch('loadResourcesFail', { error });
              throw error;
            });
        },
      };
    },
    abstractSelector: state => ({
      resources: state[pluralResource],
    }),
  };
}
